import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../lib/cn.js';
export const Callout = forwardRef(function Callout({ arrow = 'left', className, style, children }, ref) {
    return (_jsxs("div", { ref: ref, role: "dialog", "aria-modal": "false", style: style, className: cn('absolute z-10 w-80 rounded-3 border border-[var(--color-accent)] bg-[var(--color-surface)] p-5 shadow-[0_20px_60px_-10px_rgba(0,0,0,0.6)]', className), children: [_jsx("span", { "aria-hidden": true, className: cn('absolute size-3 rotate-45 border-s border-t border-[var(--color-accent)] bg-[var(--color-surface)]', 
                // Arbitrary values must use square brackets. Earlier
                // `inset-block-start-(-7px)` used parentheses and would have
                // been silently dropped by Tailwind, leaving the arrow
                // mispositioned for `arrow="top"`. Both branches now use
                // `[inset-…:-7px]` form so the offset survives.
                arrow === 'left'
                    ? '[inset-inline-start:-7px] inset-block-start-7'
                    : '[inset-block-start:-7px] inset-inline-start-7') }), children] }));
});
